<template>
  <div
    class="loginPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="title">
      <div class="logo flex-rowc">
        <!-- <el-image
          style="width: 253px; height: 28px"
          :src="require('@/assets/images/login_logo1.png')"
        ></el-image>
        <el-image
          style="width: 101px; height: 28px"
          :src="require('@/assets/images/login_logo2.png')"
        ></el-image> -->
      </div>
      <div class="logo2 flex-rowc">
        <el-image
          style="width: 552px; height: 60px"
          :src="require('@/assets/images/login_logo3.png')"
        ></el-image>
      </div>
      <div class="txt flex-rowc">
        <!-- <h1>用户登录</h1> -->
        <span class="left">[</span> SPR Plus
        跨境新零售&供销存一体化管理服务平台 <span class="right">]</span>
      </div>
    </div>
    <div class="form_wrap flex-rowc">
      <div class="primary-button-plain flex-rowc" @click="handleScan">
        <i class="iconfont icon-erweima"></i> 企微扫码登录
      </div>
    </div>
    <!-- <router-link class="primary-button" to="/login">跳转</router-link> -->

    <!-- 扫码登录 start -->
    <!-- <div class="custom_dialog" v-show="isShow">
      <div class="custom_wrap">
        <div class="close_icon" @click="isShow = false"><i class="iconfont icon-guanbi"></i></div>
        <div class="main flex-rowc">
          <iframe src="http://spr.ky51.cn/service/qywx/qrcode.aspx" scrolling="no" frameborder="0" width="200" height="300"></iframe>
        </div>
        <div class="dialog_footer flex-rowc">
          <div class="btn" @click="isShow = false">确认</div>
          <div class="close" @click="isShow = false">←关闭</div>
        </div>
      </div>
    </div> -->
    <!-- 扫码登录 end -->
  </div>
</template>
<script>
import { getUserInfo } from "../api/api";
import { getQyLogin, checkToken } from "../api/qyChat";
export default {
  name: "qyLogin",
  data() {
    return {
      fullscreenLoading: false,
      numCode: "",

      loading: false,
      isShow: false,
    };
  },
  created() {
    let { id, token } = this.$route.params;
    if (id != '${userid}' && token != "${token}") {
      this.checkToken();
    }
  },
  mounted() {},
  methods: {
    // 扫码
    handleScan() {
      // 中间页面
      // https://apidev.winksshowp.com/service/qywx/qrcode_info.aspx
      // https://api.winksshowp.com/service/qywx/qrcode_info.aspx
      // http://spr.ky51.cn/service/qywx/qrcode_info.aspx

      // 二维码页面
      // 维应开发版扫码登录：https://apidev.winksshowp.com/service/qywx/qrcode.aspx?appid=3
      // 维应产线版扫码登录：https://api.winksshowp.com/service/qywx/qrcode.aspx?appid=2003
      // 月峰扫码登录：http://adminstage.thinksway.cn/service/qywx/qrcode.aspx
      // 月峰扫码登录（旧版）：http://spr.ky51.cn/service/qywx/qrcode.aspx

      location.href =
        "https://apidev.winksshowp.com/service/qywx/qrcode.aspx?appid=3";
    },
    // token 验证
    checkToken() {
      let { id, token } = this.$route.params;
      checkToken({ userid: id, token }).then((res) => {
        if (res.result) {
          this.scanLogin();
        } else {
          this.$message.error(res.message || "网络请求错误，请稍后～");
        }
      });
    },

    // 一键登录
    scanLogin() {
      let { id } = this.$route.params;
      this.loading = true;
      getQyLogin({ qywx_userid: id }).then((res) => {
        if (res.result) {
          this.loading = false;
          let message = this.$message.success(res.message);
          this.$store.commit("updateOpenid", res.code);
          this.getUserInfo(res.code);
          setTimeout(() => {
            message.close();
            // this.$router.push("/home");
          }, 1000);
        } else {
          this.loading = false;
          this.$message.error(res.message || "接口失效，请稍后～");
        }
      });
    },
    getUserInfo(openid) {
      getUserInfo({ openid: openid }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
          if (res.mobile) {
            this.$store.commit("setUserLoginType", 1);
            setTimeout(() => {
              this.$router.push("/home");
            }, 1500);
          } else {
            setTimeout(() => {
              this.$router.push("/guide");
            }, 1000);
          }
        }
      });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
  },
};
</script>
<style lang="less" scoped>
.loginPage {
  padding: 0 60px;
  .title {
    padding: 35px 0 26px;
    border-bottom: 6px solid #6e5d87;
    .logo2 {
      margin: 18px 0;
    }
    .txt {
      font-size: 18px;
      color: #000000;
      position: relative;
      span {
        &.left {
          margin-right: 15px;
        }
        &.right {
          margin-left: 15px;
        }
      }
      h1 {
        position: absolute;
        left: 0;
        font-size: 20px;
        color: #444444;
      }
    }
  }
  .form_wrap {
    height: 62vh;
    overflow-y: scroll;
    width: 780px;
    margin: 60px auto 0;
    &::-webkit-scrollbar {
      display: none;
    }
    .verify_wrap {
      margin-top: 35px;
      margin-bottom: 25px;
      .verify-code {
        margin-bottom: 20px;
        .verify-code-change {
          margin-left: 20px;
        }
      }
    }
    .primary-button-plain {
      // margin-left: 40px;
      .icon-erweima {
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .tip {
      font-size: 16px;
      color: #828282;
      margin: 35px auto;
      p {
        color: #ff0012;
        cursor: pointer;
      }
    }
  }
  .custom_dialog {
    .custom_wrap {
      width: 500px;
      .main {
        margin: 10px 0 40px;
      }
    }
  }
}
</style>